import { defineMessages } from 'react-intl'

const messages = defineMessages({
  poweredBy: {
    id: 'app.composer.footer.poweredByDrift',
    description: 'Branding link to our marketing website',
    defaultMessage: "Chat {bolt} by {drift}",
  },
  meetingPoweredBy: {
    id: 'app.composer.footer.meetingPoweredByDrift',
    description: 'Branding link to our marketing website for meetings',
    defaultMessage: 'Meeting {bolt} by {drift}',
  },
  submitButtonLabel: {
    id: 'app.form.label.submit',
    description: 'Text for a submit button',
    defaultMessage: 'Submit',
  },
  emailAddressInputLabel: {
    id: 'app.form.label.emailAddress',
    description: "Form label for the user's email address",
    defaultMessage: 'Email address',
  },
  requiredField: {
    id: 'app.form.requiredField',
    description: 'Displayed if the user omits a required field in a form',
    defaultMessage: 'Required',
  },
  invalidEmail: {
    id: 'app.form.invalidEmail',
    description: 'Displayed if the user enters an invalid email into a form',
    defaultMessage: 'Invalid email address',
  },
  welcomeMessage: {
    id: 'app.newConversation.welcomeMessage',
    description: 'Message greeting that appears on the New Conversation screen',
    defaultMessage: "How can we help? We're here for you!",
  },
  defaultAwayMessageCopy: {
    id: 'messenger.offlineFeedback.awayMessageDefaultCopy',
    description: 'Message shown to a user indicating that the Team is currently away or offline',
    defaultMessage: 'Hi there! So we’re away right now, but if you leave us a message we’ll get back to you soon.',
  },
  connecting: {
    id: 'app.status.connecting',
    description: 'Status message displayed when the chat is connecting',
    defaultMessage: 'Connecting',
  },
  connectionFailed: {
    id: 'app.status.connectionFailed',
    description: 'Status message displayed when the chat connection failed',
    defaultMessage: 'Connection failed.',
  },
  connectionRetry: {
    id: 'app.status.connectionRetry',
    description: 'Action button to retry the chat connection',
    defaultMessage: 'Retry?',
  },
  connected: {
    id: 'app.status.connected',
    description: 'Status message displayed when the chat is successfully connected',
    defaultMessage: 'Connected',
  },
  asyncMessageContactPrompt: {
    id: 'app.async.contactPrompt',
    description: 'Prompt to ask a user what the best method of contact is.',
    defaultMessage: 'How can we reach you?',
  },
  asyncMessageThankYou: {
    id: 'app.async.thankYou',
    description: 'Confirmation message displayed at the end of the async message flow',
    defaultMessage: "Thanks for your message. We'll follow up in a bit at {email}",
  },
  scheduleAMeeting: {
    id: 'app.meeting.scheduleAMeeting',
    description: '"Schedule a meeting" header',
    defaultMessage: "Schedule a Meeting",
  },
  scheduleAMeetingError: {
    id: 'app.meeting.scheduleAMeetingError',
    description: 'Error message displayed when something goes wrong.',
    defaultMessage: "Sorry about that! We ran into an error on our end - please try again.",
  },
  scheduleAMeetingTimePassedError: {
    id: 'app.meeting.scheduleAMeetingTimePassedError',
    description: 'Error message displayed when the time has passed.',
    defaultMessage: "Sorry, the time you chose has already passed! Please pick a new time.",
  },
  scheduleAMeetingAlreadyBookedError: {
    id: 'app.meeting.scheduleAMeetingAlreadyBookedError',
    description: 'Error message displayed when the time is already booked.',
    defaultMessage: "Sorry, it looks like someone has already scheduled this time slot with {name}.",
  },
  chooseNewTime: {
    id: 'app.meeting.chooseNewTime',
    description: 'Button CTA to pick a new time',
    defaultMessage: "Choose a new time",
  },
  retry: {
    id: 'app.meeting.retry',
    description: 'Button CTA to retry a failed request',
    defaultMessage: "Retry",
  },
  schedule: {
    id: 'app.meeting.schedule',
    description: 'Button CTA to schedule a meeting',
    defaultMessage: "Schedule",
  },
  searchTimeZones: {
    id: 'app.meeting.searchTimeZones',
    description: 'Placeholder for time zone search box',
    defaultMessage: "Search Time Zones",
  },
  timeZone: {
    id: 'app.meeting.timeZone',
    description: 'Header on selected time zone',
    defaultMessage: "Time Zone",
  },
  selectADay: {
    id: 'app.meeting.selectADay',
    description: 'Header on the day picker',
    defaultMessage: "Select a day",
  },
  selectATime: {
    id: 'app.meeting.selectATime',
    description: 'Header on the time picker',
    defaultMessage: "Select a time",
  },
  minute: {
    id: 'app.meeting.minute',
    description: 'A single minute',
    defaultMessage: "minute",
  },
  minutes: {
    id: 'app.meeting.minutes',
    description: 'The plural of minute',
    defaultMessage: "minutes",
  },
  hour: {
    id: 'app.meeting.hour',
    description: 'A single hour',
    defaultMessage: "hour",
  },
  hours: {
    id: 'app.meeting.hours',
    description: 'The plural of hour',
    defaultMessage: "hours",
  },
  next: {
    id: 'app.meeting.next',
    description: 'Next page',
    defaultMessage: "Next",
  },
  prev: {
    id: 'app.meeting.prev',
    description: 'Previous page',
    defaultMessage: "Prev",
  },
})

export default messages



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/translations/messages.js
// module id = nAcP
// module chunks = 88